import { config } from '@/config';

/**
 * Request the backend to auto-tag a note using the user's existing tag taxonomy.
 * Callers handle errors — this function throws on non-ok responses.
 */
export const requestAutoTag = async (token: string, noteId: string): Promise<void> => {
  const response = await fetch(`${config.apiUrl}/tags/auto-tag`, {
    method: 'POST',
    headers: {
      authorization: `Bearer ${token}`,
      'content-type': 'application/json',
    },
    body: JSON.stringify({ note_id: noteId }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const detail = (errorData as Record<string, string>).detail || `Auto-tag failed (${response.status})`;
    throw new Error(detail);
  }
};
